import Operations from '../../functionalInterface/operations';
export const call = (route, body = {}, files = undefined, replace = true) => ({
    type: Operations.FUNCTIONAL_CALL,
    payload: { route, body, files, replace },
});
